import * as React from "react";
import {TextInput} from "./TextInput";
import {ErlButtonBig} from "./ErlButtonBig";
import './partnerLogin.css';
import {PasswordInput} from "./PasswordInput";
import {LoaderSpinner} from "./LoaderSpinner";
import {InputFieldState} from "../../shared/helpers/InputFieldState";

interface PartnerLoginFormState {
    username: InputFieldState,
    password: InputFieldState,
    fetchRunning: boolean,
}


/**
 * Text Input Element
 */
export class PartnerLoginForm extends React.Component<{}, PartnerLoginFormState> {

    state: PartnerLoginFormState;

    apiHeaders: any;

    constructor(props: any) {
        super(props);

        this.state = {
            username: {value: ''},
            password: {value: ''},
            fetchRunning: false,
        };

        this.apiHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

    }

    submit() {

        if (this.state.fetchRunning) {
            return;
        }

        this.setState({fetchRunning: true});

        fetch('/wp-json/erl-api/v1/partner/login/', {
            method: 'POST',
            headers: this.apiHeaders,
            body: JSON.stringify(this.state)
        })
            .then(res => res.json())
            .then((data) => {

                if (data.success === false) {
                    this.setState({fetchRunning: false});
                    Object.keys(data).map(key => {
                        this.setState({
                            [key]: data[key]
                        } as unknown as Pick<PartnerLoginFormState, keyof PartnerLoginFormState>)

                    });
                } else {
                    if (data.redirect_url) {
                        window.location.href = data.redirect_url;
                    } else {
                        this.setState({fetchRunning: false});
                        console.log(data);
                    }
                }
            }).catch(() => {
            this.setState({fetchRunning: false});
        });
    }

    render() {
        return <div className="partner-login">
            <img className="partner-logo" alt=""
                 src="/wp-content/themes/erlbau-reloaded/images/partner-logo-small.svg"/>
            <form onSubmit={(e) => {
                this.submit();
                e.preventDefault();
            }
            }>
                <TextInput darkMode={true} label="Benutzername" state={this.state.username} onChange={value => {
                    this.setState({username: {value: value}});
                }}/>
                <div className="spacer"/>
                <PasswordInput darkMode={true} label="Passwort" state={this.state.password} onChange={value => {
                    this.setState({password: {value: value}});
                }}/>
                {this.state.fetchRunning ? (
                    <LoaderSpinner/>
                ) : (
                    <ErlButtonBig type="submit" darkMode={true} label="Einloggen" onclick={() => this.submit()}/>
                )}
            </form>
        </div>
    }
}
